module.exports = __webpack_public_path__ + "img/Memberkit.822a2ef0.svg";